const base_url = import.meta.env.VITE_APP_PUBLIC_BACKEND_URL;

const getAuthHeader = () => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("agent_token");
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  }
  return {};
};

const base_headers = (type = null) => {
  const authHeader = getAuthHeader();

  if (type === "multipart") {
    return {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...authHeader,
    };
  }
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
    ...authHeader,
  };
};

const buildUrl = (path, queryParams = {}) => {
  let url = `${base_url}${path}`;
  const filteredParams = Object.fromEntries(
    Object.entries(queryParams).filter(([_, v]) => v != null && v !== "")
  );
  if (Object.keys(filteredParams).length > 0) {
    url += "?" + new URLSearchParams(filteredParams);
  }
  return url;
};

const handleResponse = async (response) => {
  try {
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data.message || "Request failed");
      error.response = { status: response.status, data };
      throw error;
    }
    return { data, status: response.status, ok: response.ok };
  } catch (error) {
    if (error.response) throw error;
    const err = new Error("Request failed");
    err.response = { status: response.status, data: {} };
    throw err;
  }
};

const api = {
  get: async (endpoint, { params = {}, config = {} } = {}) => {
    const url = buildUrl(endpoint, params);
    const response = await fetch(url, {
      method: "GET",
      headers: { ...base_headers(), ...config.headers },
      credentials: "include",
    });
    return handleResponse(response);
  },

  post: async (endpoint, body = {}, { params = {}, config = {} } = {}) => {
    const url = buildUrl(endpoint, params);
    const isFormData = body instanceof FormData;

    // For FormData, don't set Content-Type - browser sets it with boundary
    const requestHeaders = isFormData
      ? { ...getAuthHeader(), Accept: "application/json" }
      : { ...base_headers(), ...config.headers };

    const response = await fetch(url, {
      method: "POST",
      headers: requestHeaders,
      body: isFormData ? body : JSON.stringify(body),
      credentials: "include",
    });
    return handleResponse(response);
  },

  put: async (endpoint, body = {}, { params = {}, config = {} } = {}) => {
    const url = buildUrl(endpoint, params);
    const isFormData = body instanceof FormData;

    // For FormData, don't set Content-Type - browser sets it with boundary
    const requestHeaders = isFormData
      ? { ...getAuthHeader(), Accept: "application/json" }
      : { ...base_headers(), ...config.headers };

    const response = await fetch(url, {
      method: "PUT",
      headers: requestHeaders,
      body: isFormData ? body : JSON.stringify(body),
      credentials: "include",
    });
    return handleResponse(response);
  },

  delete: async (endpoint, { params = {}, config = {} } = {}) => {
    const url = buildUrl(endpoint, params);
    const response = await fetch(url, {
      method: "DELETE",
      headers: { ...base_headers(), ...config.headers },
      credentials: "include",
    });
    return handleResponse(response);
  },
};

export default api;
